import {Injectable, Injector} from "@angular/core";
import {component, EntityData, EntityModel, field, identifier, transientField} from "@fedelta-pos/data-client";
import {AddressData} from "../customer-info/address.data";

export class IdentityData extends EntityData<IdentityData> {
    @identifier id: string;
    @field mobilePhone: string;
    @field email: string;
    @field password: string;
    @field verificationId: string;
    @field verificationCode: string;
    @field firstName: string;
    @field lastName: string;
    @field dob: string;
    @field gender: number;
    @field deliveryInstructions: string;
    @component homeAddress: AddressData;

    @transientField memberNo: string;
}

@Injectable()
export class IdentityEntityModel extends EntityModel<IdentityData> {
    constructor(injector: Injector) {
        console.log("--- IdentityEntityModel");

        super(injector, IdentityData);
    }
}



// WEBPACK FOOTER //
// ./src/app/identity/identity-entity.model.ts